import React from 'react';
import { Col, Row, Table } from 'reactstrap';

import Date from '@/components/common/date';
import { Datepicker, Input } from '@/components/form';
import ResourceList from '@/components/resources/list';
import View from '@/components/view';

export default () => (
  <View>
    <ResourceList
      resource="Report"
      deleteMultiple
      filters={() => (
        <Row>
          <Col lg={3}>
            <Input name="name" />
          </Col>
          {/* <Col lg="3">
            <Autocomplete name="community" clearable resource="Community" display="name" tag="name" />
          </Col> */}
          <Col lg={3}>
            <Datepicker name="['startDate[after]']" label="report.start_date.after" />
          </Col>
          <Col lg={3}>
            <Datepicker name="['startDate[before]']" label="report.start_date.before" />
          </Col>
          <Col lg={3}>
            <Datepicker name="['endDate[after]']" label="report.end_date.after" />
          </Col>
          <Col lg={3}>
            <Datepicker name="['endDate[before]']" label="report.end_date.before" />
          </Col>
          <Col lg={3}>
            <Datepicker name="['lastSync[after]']" label="report.last_sync.after" />
          </Col>
          <Col lg={3}>
            <Datepicker name="['lastSync[before]']" label="report.last_sync.before" />
          </Col>
        </Row>
      )}
      body={({ collection, renderColumn, renderItemActions, renderSelect }) => (
        <Table responsive hover>
          <thead className="thead-light">
            <tr>
              {renderColumn(renderSelect('*'), false)}
              {renderColumn('id')}
              {renderColumn('name')}
              {renderColumn('startDate')}
              {renderColumn('endDate')}
              {renderColumn()}
            </tr>
          </thead>
          <tbody>
            {collection.map((item) => (
              <tr key={item.id}>
                <td>{renderSelect(item.id)}</td>
                <td>{item.id}</td>
                <td>{item.name}</td>
                <td>
                  <Date>{item.startDate}</Date>
                </td>
                <td>
                  <Date>{item.endDate}</Date>
                </td>
                <td>{renderItemActions(item, null, true)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    />
  </View>
);
